import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-form-flex',
  template: `
    <div
      class="content" 
      [fxLayout]="to.fxLayout" 
      fxLayout.xs="column" \
      [fxLayoutAlign]="to.fxLayoutAlign || 'start'"
      [fxLayoutGap]="to.fxLayoutGap || '0px'"
      fxFlexFill
    >
      <formly-field *ngFor="let f of field.fieldGroup" [field]="f">
      </formly-field>
    </div>
  `,
})
export class FlexLayoutType extends FieldType {
}